/* @flow */

import React from 'react';
import { Header, Grid, Message } from 'semantic-ui-react';
import OctoResourceImage from 'shared/components/OctoResourceImage';

type Props = {
  block: EditorialBlock,
};

const View = ({ block, onSerialize }: Props) => {
  if (block.image) {
    return (
      <Grid columns={2} textAlign="center">
        <Grid.Column>
          <Header as="h3" content={block.caption} />
          <OctoResourceImage
            strategy={block.image.strategy}
            resource={block.image}
          />
        </Grid.Column>
      </Grid>
    );
  }

  return <Message icon="info" header="Aucune image spécifiée" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/image/View.js